import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'css-spinner',
	templateUrl: "./css-spinner.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./css-spinner.scss")]
})
export class CssSpinner {
	@Input() visible;

	getVisible() {
		return this.visible != null ? this.visible : true;
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/css-spinner/css-spinner.component.ts